import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { useState } from "react";

interface PasswordFormProps {
  onUpdatePassword: (newPassword: string) => void;
  onCancel: () => void;
}

const PasswordForm = ({ onUpdatePassword, onCancel }: PasswordFormProps) => {
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleUpdatePassword = async () => {
    try {
      setIsSubmitting(true);
      await onUpdatePassword(password);
      setPassword("");
      setIsSubmitting(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-full space-y-12">
      {/* update password form */}
      <div className="space-y-6">
        <div className="space-y-2">
          <Label htmlFor="password">New Password</Label>
          <Input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="New password"
            className="bg-card"
          />
        </div>
      </div>
      {/* update password buttons */}
      <div className="w-full inline-flex items-end justify-center gap-4">
        <button
          type="button"
          onClick={handleUpdatePassword}
          disabled={isSubmitting}
          className={cn("text-sm text-muted-foreground hover:text-foreground mt-2", isSubmitting && "opacity-50 cursor-not-allowed")}
        >
          {isSubmitting ? "Updating..." : "Update"}
        </button>
        <div className="w-0 border-l-2 border-border h-2/3" />
        <button
          type="button"
          onClick={onCancel}
          disabled={isSubmitting}
          className={cn("text-sm text-muted-foreground hover:text-foreground mt-2", isSubmitting && "opacity-50 cursor-not-allowed")}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default PasswordForm;